import isObject from 'lodash-es/isObject';
import { ComponentType, ReactNode, Suspense } from 'react';

function isReactLazyComponent(Component: ComponentType): boolean {
    return (
        isObject(Component) &&
        typeof Component.$$typeof !== 'undefined' &&
        Component.$$typeof === Symbol.for('react.lazy')
    );
}

interface LazyComponentProps {
    component: ComponentType;
    fallback?: ReactNode;
    [key: string]: unknown;
}

function LazyComponent({ component: Component, fallback = null, ...props }: LazyComponentProps) {
    if (isReactLazyComponent(Component)) {
        return (
            <Suspense fallback={fallback}>
                <Component {...props} />
            </Suspense>
        );
    }
    return <Component {...props} />;
}

export default LazyComponent;
